import { WsSyncConfigRepositoryProvider } from '../infrastructure/repositories/ws-sync-config.repository.impl';
import { WsSyncLogsRepositoryProvider } from '../infrastructure/repositories/ws-sync-logs.repository.impl';

// Solo los providers de los tokens abstractos (mapean al impl concreto vía useClass).
// El resto de clases (state, use cases, repos impl, mock service) están en providedIn: 'root'
// de manera explícita para garantizar singleton real en toda la app. NO listar clases con
// providedIn: 'root' aquí porque crearía instancias por componente y rompería el estado
// compartido entre el switch y el overlay.
export const WsSelectorIaBinding = [
  WsSyncConfigRepositoryProvider,
  WsSyncLogsRepositoryProvider,
];
